import { useEffect, useState } from 'react';

/**
 * Custom hook to handle language changes in the application
 * @param {Object} translationService - The translation service object (data.t)
 * @returns {number} A key that changes when language changes, to force re-renders
 */
const useLanguageChange = (translationService) => {
  const [langKey, setLangKey] = useState(0);

  useEffect(() => {
    if (!translationService) return;

    const handleLangChange = () => {
      // Increment the key to trigger a re-render when language changes
      setLangKey(prevKey => prevKey + 1);
    };

    // Subscribe to language change events
    translationService.onLangChange(handleLangChange);
    
    // Cleanup the subscription when component unmounts
    return () => {
      translationService.offLangChange(handleLangChange);
    };
  }, [translationService]);

  return langKey;
};

export default useLanguageChange;
